import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RxJsonpInterceptor } from '../interceptors/rx-jsonp.interceptor';

@NgModule({
  providers: [
    provideHttpClient(withJsonpSupport(), withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RxJsonpInterceptor,
      multi: true,
    }
  ],
})
export class ThirdPartyLibraryModule {}
